import { render, staticRenderFns } from "./MemberSelector.vue?vue&type=template&id=0c5dc3e0&scoped=true"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"
import style0 from "./MemberSelector.vue?vue&type=style&index=0&id=0c5dc3e0&prod&lang=css"
import style1 from "./MemberSelector.vue?vue&type=style&index=1&id=0c5dc3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5dc3e0",
  null
  
)

export default component.exports